import api from '@/api'

export default class HomeApi {
	static async init(data) {
		const http = api();
		return http.post('/site/index', data).then(function (response) {
			return response.data
		})
	}

	static async toBot(data) {
		const http = api();
		return http.post('/site/to-bot', data).then(function (response) {
			return response.data
		})
	}
}
